import type { ReactNode } from 'react';
import { Icone } from '../icones.tsx';

/**
 * Bouton d'export PDF — même endroit, même libellé, sur tous les écrans.
 *
 * `onClick` fait le travail (voir `exporter-pdf.ts`) ; ce composant ne pose
 * que l'apparence, pour qu'un futur changement de mécanisme (PDF serveur,
 * impression navigateur…) se fasse à un seul endroit visuel.
 */
export function BoutonImprimer({ onClick }: { onClick: () => void }): ReactNode {
  return (
    <button type="button" className="bouton--discret" onClick={onClick}>
      <Icone nom="imprimante" taille={16} />
      Imprimer
    </button>
  );
}
